import { TicketModule } from "../../common/model/ticket/ticket";
import ticketService from "../../common/services/ticket-api-service";
import {
  type ActionTree,
  type GetterTree,
  type Module,
  type MutationTree,
} from "vuex";
import { type TicketDetailState } from "./ticket-detail-state";
import { type RootState } from "../../root/store/state";

const state: TicketDetailState = {
  selectedTicketId: "" as string,

  ticketDetailCosmosOnlyComment: null as TicketModule.TicketComment | null,
  ticketControlDisabled: false as boolean,
  ticketDetailTitleisDirty: false as boolean,
  ticketDetailDescriptionisDirty: false as boolean,
  ticketDetailCommentisDirty: false as boolean,
  ticketDetailTimelineCommentisDirty: false as boolean,
  ticketDetailContactisDirty: false as boolean,
  ticketDetailCalendarisDirty: false as boolean,
  ticketDetailTimeSpentisDirty: false as boolean,
  ticketTimelineNewComments: 0 as number,
  trackChangesForComment: false as boolean,
  commentCount: 0 as number,
  timeSpentAdded: false as boolean,
  unsubscribeSignalRGroup: false as boolean,
  timelineTabId: -1 as number,
  showAddThirdPartyConversationModal: null as any,
  jumpToComment: null as any,
  changeToTimelineTab: 0 as number,
  changeToTimelineTabType: "" as string,
  shortcutDelayProps: null as any,
  isTicketFilled: false as boolean,
  tpcIds: [] as number[],
  approvalIds: [] as string[],
  requestedApprovalTicketId: "" as string,
};

const getters: GetterTree<TicketDetailState, RootState> = {
  getTicketsDetailCosmosOnlyComment(state): TicketModule.TicketComment | null {
    return state.ticketDetailCosmosOnlyComment;
  },

  getticketDetailCommentisDirty(state): boolean {
    return state.ticketDetailCommentisDirty;
  },

  getTicketTimeLineFreshComment(state): boolean {
    return state.trackChangesForComment;
  },

  getJumpToComment(state): any {
    return state.jumpToComment;
  },

  getTicketId(state): string {
    return state.selectedTicketId;
  },

  getTicketFillingState(state): boolean {
    return state.isTicketFilled;
  },

  getTpcIds(state): number[] {
    return state.tpcIds;
  },

  getApprovalIds(state): string[] {
    return state.approvalIds;
  },

  getRequestedApprovalTicketId(state): string {
    return state.requestedApprovalTicketId;
  },

  getCommentCount(state): number {
    return state.commentCount;
  },
};

const mutations: MutationTree<TicketDetailState> = {
  SET_TICKETSDETAILCOSMOSONLYCOMMENT(state, value: TicketModule.TicketComment) {
    state.ticketDetailCosmosOnlyComment = value;
  },

  SET_TICKETDETAILTIMELINECOMMENTDIRTYVAL(state, value) {
    state.ticketDetailTimelineCommentisDirty = value;
  },

  SET_SELECTEDTICKETID(state, value) {
    state.selectedTicketId = value;
  },

  SET_TicketFillingState(state, value) {
    state.isTicketFilled = value;
  },

  SET_TpcIds(state, value) {
    state.tpcIds = value;
  },

  SET_ApprovalIds(state, value) {
    state.approvalIds = value;
  },

  /** The ticket the list's "Waiting for approval" chip opened; consumed (see
   * ticket-conversation-tabs.ts) once that ticket's approval tab can be selected. */
  SET_RequestedApprovalTicketId(state, value: string) {
    state.requestedApprovalTicketId = value ?? "";
  },

  SET_COMMENT_COUNT(state, value: number) {
    state.commentCount = value;
  },
};

const actions: ActionTree<TicketDetailState, RootState> = {
  ticketDetailCosmosCommentRequest({ state, commit }, id: number): any {
    return new Promise<any>((resolve, reject) => {
      ticketService
        .getTicketCosmosCommentById(id, {})
        .then((result: TicketModule.TicketComment) => {
          result.attachments &&
            (result.attachments as TicketModule.Attachments[]).forEach(
              (file: TicketModule.Attachments) => {
                file.isDeleted = false;
                file.isNew = false;
                const extension = file.name.substring(
                  file.name.lastIndexOf("."),
                  file.name.length,
                );
                file.extensionFile =
                  [".png", ".jpg", ".jpeg", ".gif", ".bitmap"].indexOf(
                    extension.toLowerCase(),
                  ) > -1;
              },
            );
          if (
            state.ticketDetailCosmosOnlyComment != null &&
            (state.ticketDetailCosmosOnlyComment.updatedOn != null ||
              result.updatedOn != null) &&
            state.ticketDetailCosmosOnlyComment.updatedOn == result.updatedOn
          ) {
            resolve([]);
          } else {
            commit("SET_TICKETSDETAILCOSMOSONLYCOMMENT", result);
            resolve(result);
          }
        })
        .catch((error: any) => {
          console.log(error);
          reject(error);
        });
    });
  },

  async ticketDetailTimelineCommentIsDirty({ commit }) {
    commit("SET_TICKETDETAILTIMELINECOMMENTDIRTYVAL", true);
  },

  async ticketDetailTimelineCommentIsNotDirty({ commit }) {
    commit("SET_TICKETDETAILTIMELINECOMMENTDIRTYVAL", false);
  },

  loadTotalComments({ commit }, count: number) {
    commit("SET_COMMENT_COUNT", typeof count === "number" ? count : 0);
  },
};

const namespaced: boolean = true;
export const ticketDetailModule: Module<TicketDetailState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
